import i18next from "../../services/language/i18next";
import {Trans} from "react-i18next";
import React from "react";

export const getStatusText = ({is_paused, is_enabled, is_up}) => {
  if (!is_enabled && is_enabled !== undefined) {
    return {name: i18next.t("table:status.disabled", "Disabled"), color: "var(--dark)"};
  } else if (is_paused) {
    return {name: i18next.t("table:status.inWork", "In Work"), color: "var(--warning)"};
  } else if (is_up) {
    return {name: i18next.t("table:status.up", "Up"), color: "var(--success)"};
  } else if (is_up === false) {
    return {name: i18next.t("table:status.down", "Down"), color: "var(--danger)"};
  }

  return {name: i18next.t("table:status.pending", "Pending"), color: "#c0c4c9"};
};

export const getToolTipInfo = ({is_up, is_enabled, is_paused, pause_finish, state_effective_since, info}) => {
  if (!is_enabled && is_enabled !== undefined) {
    return {display: false, content: ""};
  } else if (is_paused) {
    const date = pause_finish.match(/\d{4}-\d{2}-\d{2}/);
    const time = pause_finish.match(/\d{2}:\d{2}:\d{2}/);
    return {content: i18next.t("table:tooltip.checkPause", `The pause will end at ${time}, ${date}`, {time, date}), display: true};
  } else {
    const date = state_effective_since?.match(/\d{2}\/\d{2}\/\d{4}/);
    const time = state_effective_since?.match(/\d{2}:\d{2}:\d{2}/);

    const stateText = `${is_up ? "Up" : "Down"} ${i18next.t("table:tooltip.since", "since")} ${time}, ${date}`;

    const StateTransComponent = <Trans i18nKey="table:tooltip.stateSince" values={{stateText}}>
      State ${stateText}
    </Trans>;

    // info - переменная для страницы check_details, она не равна null || undefined, только если status Down.
    return {
      content: info || StateTransComponent,
      display: !!info || !!state_effective_since
    };
  }
};